export const courseManager = {
  state: {
    course: [],
    courseMaterials: [],
    dropzonesLoaded: {}
  },
  mutations: {
    SET_Course(state, course) {
      state.course = course;
    },
    SET_DropzoneLoaded(state, {id, value}) {
      state.dropzonesLoaded = {
        ...state.dropzonesLoaded,
        [id]: value
      }
    },
    SET_CourseMaterials(state, courseMaterials) {
      state.courseMaterials = courseMaterials;
    },
    ADD_CourseMaterials(state, asset) {
      state.courseMaterials.push(asset);
    },
    REMOVE_CourseMaterials(state, index) {
      state.courseMaterials.splice(index, 1);
    },
    EDIT_CourseMaterials(state, asset, index) {
      state.courseMaterials[asset.index].description = asset.description;
      state.courseMaterials[asset.index].title = asset.title;
    },
    CLEAR_All(state) {
      state.course = [],
      state.courseMaterials = [],
      state.dropzoneLoaded = false;
    },

  },
  actions: {
    setCourse: ({commit, state}, newValue) => {
      commit('SET_Course', newValue)
      return state.course
    },
    clearAll: ({commit}) => {
      commit('CLEAR_All')
    },
    setCourseMaterials: ({commit, state}, newValue) => {
      commit('SET_CourseMaterials', newValue)
      return state.courseMaterials
    },
    addCourseMaterials: ({commit, state}, asset) => {
      commit('ADD_CourseMaterials', asset)
      return state.courseMaterials
    },
    removeCourseMaterials: ({commit, state}, index) => {
      commit('REMOVE_CourseMaterials', index)
      return state.courseMaterials
    },
    editCourseMaterials: ({commit, state}, asset) => {
      commit('EDIT_CourseMaterials', asset, asset.index);
      return state.courseMaterials
    },
    setDropzoneLoaded: ({commit}, dropzoneLoaded) => {
      commit('SET_DropzoneLoaded', dropzoneLoaded);
    }
  },
  getters: {
    course: (state) => {
      return state.course
    },
    courseMaterials: (state) => {
      return state.courseMaterials
    },
    dropzoneLoaded: (state) =>  (id) => {
      return state.dropzonesLoaded[id] || false;
    }
  }
};
